import React, { useEffect, useMemo, useState } from "react";
import { getPerformanceRatingTypes } from "common/services/performance-rating.service";
import { normalize } from "common/lib/normalize";
import { FilterValueSelect } from "Components/Common/TableFilters";
import {
  RatingOptionLabel,
  ratingTypeOption,
} from "Components/Common/PerformanceRatingTone";

type RatingTypeFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const RatingTypeFilter = ({ onChange, value }: RatingTypeFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getPerformanceRatingTypes({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => data.map(ratingTypeOption), [data]);

  return (
    <FilterValueSelect
      id="ratingTypeFilter"
      placeholder="Select Performance Rating"
      value={value}
      onChange={onChange}
      options={options}
      isLoading={loading}
      formatOptionLabel={RatingOptionLabel}
    />
  );
};

export default RatingTypeFilter;
